import { CalendarCommitmentSource, CalendarFilterState, UnifiedCalendarItem } from '../../../types/calendar';

/** Transport only: support revisions and billing arithmetic remain on the server. */
export interface CalendarCommitmentsResult {
  ok: true; from: string; to: string; checkedAt: string;
  items: (Omit<UnifiedCalendarItem, 'commitment'> & { source: CalendarCommitmentSource })[];
  replacedJobIds: string[];
  errors: Partial<Record<'support' | 'stripe', string>>;
  warnings: Partial<Record<'support' | 'stripe', string[]>>;
}

export function mergeCalendarCommitments(items: UnifiedCalendarItem[], result: CalendarCommitmentsResult | null, filters: CalendarFilterState): UnifiedCalendarItem[] {
  const supportReady = !!result && !result.errors.support;
  const merged = items.filter(item => {
    if (item.type !== 'job_due') return true;
    const support = !!(item.jobData as any)?.support || result?.replacedJobIds.includes(item.jobData?.id || '');
    if (support) return filters.showSupport !== false && !supportReady;
    return filters.showJobs;
  });
  for (const item of result?.items || []) {
    if (item.source.kind === 'support' && (filters.showSupport === false || (item.source.completed && !filters.showCompletedSupport))) continue;
    if (item.source.kind === 'stripe' && filters.showStripePayments === false) continue;
    if (result?.errors[item.source.kind]) continue;
    merged.push({ ...item, commitment: item.source });
  }
  return Array.from(new Map(merged.map(item => [item.id, item])).values());
}

export function calendarCustomerId(item: UnifiedCalendarItem): string | undefined {
  return item.customerId || item.repeatingInvoiceData?.contactId || item.invoiceData?.Contact?.ContactID;
}
